import { render, staticRenderFns } from "./Turni.vue?vue&type=template&id=65bce8db"
import script from "./Turni.vue?vue&type=script&lang=js"
export * from "./Turni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports